<ul class="list-group">
  <li class="list-group-item h-100">
    <div class="col-md-4">
      {{ 'revenue.invoice-selector.summary.title' | translate | titlecase }}
    </div>
    <div class="col-md-4">{{ paramCount }} {{ 'profiles.search.summary.header-1' | translate }}</div>
    <div class="col-md-4 pull-right">
      <!--<button pButton type="button" class="btn btn-default pull-right" (click)="toggleSummaryVisible()">
                {{summaryVisible ? ('profiles.search.summary.hide-summary-button'|translate|titlecase) : ('profiles.search.summary.show-summary-button'|translate|titlecase)}}
            </button>-->
    </div>
    <div class="clear-fix"></div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.InvoiceInfoSearchExpressions?.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'revenue.invoice-selector.form.invoice-info.tab-title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <li class="col-xs-12" *ngFor="let expression of searchParams.InvoiceInfoSearchExpressions; let i = index">
              <div class="col-xs-1">
                <div [hidden]="i === 0">
                  <label *ngIf="expression.BinaryOperator == 0">{{
                    'shared.widgets.expression.binary-operator.and' | translate | titlecase
                  }}</label>
                  <label *ngIf="expression.BinaryOperator == 1">{{
                    'shared.widgets.expression.binary-operator.or' | translate | titlecase
                  }}</label>
                </div>
              </div>
              <div class="col-xs-2">
                {{ expression.Field | wlRegexReplace: '([a-z])([A-Z])' : 'g' : '$1 $2' | wlRegexReplace: 'Profile_' : 'g' : '' }}
              </div>
              <div class="col-xs-2">
                <label *ngIf="expression.FieldValueOperator == 0">{{
                  'shared.widgets.expression.value-operator.equals' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 1">{{
                  'shared.widgets.expression.value-operator.contains' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 2">{{
                  'shared.widgets.expression.value-operator.not-equal' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 3">{{
                  'shared.widgets.expression.value-operator.greater-than' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 4">{{
                  'shared.widgets.expression.value-operator.less-than' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 5">{{
                  'shared.widgets.expression.value-operator.in-the-period' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 6">{{
                  'shared.widgets.expression.value-operator.between' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 7">{{
                  'shared.widgets.expression.value-operator.number-of-days-until' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 8">{{
                  'shared.widgets.expression.value-operator.number-of-days-since' | translate | titlecase
                }}</label>
              </div>
              <div class="col-xs-2" *ngIf="expression.FieldValueOperator != 5 && expression.FieldValueOperator != 6">
                {{ expression.Value }}
              </div>
              <div class="col-xs-5" *ngIf="expression.FieldValueOperator == 6">
                {{ expression.Value }} {{ 'common.and' | translate }} {{ expression.Value2 }}
              </div>
              <div class="col-xs-5" *ngIf="expression.FieldValueOperator == 5">
                <label *ngIf="expression.Value == datePeriodEnum.Last1Day">{{
                  'shared.widgets.expression.date-period-options.last-1-day' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Last7Days">{{
                  'shared.widgets.expression.date-period-options.last-7-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Last30Days">{{
                  'shared.widgets.expression.date-period-options.last-30-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.MonthToDate">{{
                  'shared.widgets.expression.date-period-options.month-to-date' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.YearToDate">{{
                  'shared.widgets.expression.date-period-options.year-to-date' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Next7Days">{{
                  'shared.widgets.expression.date-period-options.next-7-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Next30Days">{{
                  'shared.widgets.expression.date-period-options.next-30-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Next60Days">{{
                  'shared.widgets.expression.date-period-options.next-60-days' | translate | titlecase
                }}</label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.AgingPeriod > 0">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'revenue.invoice-selector.form.aging.tab-title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label *ngIf="searchParams.AgingPeriod == agingPeriodEnum.AllOpen">
            {{ 'revenue.invoice-selector.form.aging.options.all-open' | translate | titlecase }}
          </label>
          <label *ngIf="searchParams.AgingPeriod == agingPeriodEnum.AllPastDue">
            {{ 'revenue.invoice-selector.form.aging.options.all-past-due' | translate | titlecase }}
          </label>
          <label *ngIf="searchParams.AgingPeriod == agingPeriodEnum.DaysPastDue30">
            {{ 'revenue.invoice-selector.form.aging.options.30-days-past-due' | translate | titlecase }}
          </label>
          <label *ngIf="searchParams.AgingPeriod == agingPeriodEnum.DaysPastDue60">
            {{ 'revenue.invoice-selector.form.aging.options.60-days-past-due' | translate | titlecase }}
          </label>
          <label *ngIf="searchParams.AgingPeriod == agingPeriodEnum.DaysPastDue90">
            {{ 'revenue.invoice-selector.form.aging.options.90-days-past-due' | translate | titlecase }}
          </label>
          <label *ngIf="searchParams.AgingPeriod == agingPeriodEnum.DaysPastDue120AndMore">
            {{ 'revenue.invoice-selector.form.aging.options.120-and-more-days-past-due' | translate | titlecase }}
          </label>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.RevenueItemNums?.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'revenue.invoice-selector.form.revenue-item.tab-title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <div *ngIf="searchParams.RevenueItemNums.length">
            <div class="clear-fix"></div>
            <ul class="list-unstyled col-sm-6">
              <li *ngFor="let revenueItem of revenueItems | slice: 0 : (allRevenueItemNumVisible ? 9999 : 2)">
                {{ revenueItem }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="form-group">
        <button
          pButton
          type="button"
          class="btn btn-default"
          *ngIf="hiddenRevenueItemNumCount > 0"
          (click)="toggleRevenueItemNumSliceEnd()"
        >
          {{ allRevenueItemNumVisible ? ('common.hide' | translate) : '+' + hiddenRevenueItemNumCount + ' ' + ('common.more' | translate) }}
        </button>
      </div>
    </div>
  </li>
</ul>
